
export const languages = [
    { value: 'es', label: 'Castellà' },
    { value: 'en', label: 'Anglès' },
    { value: 'de', label: 'Alemany' },
    { value: 'fr', label: 'Francès'}
];